import React, { Fragment, useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import AllOrder from "../../component/AllOrder";
import axios from "axios";
import { Auth } from "../../component/Auth";

// export const MyContextOrderAll = React.createContext();

const OrdersAll = () => {
  const [allOrder, setAllOrder] = useState([]);
  const [isLoading, setIsLoading] = useState({ loading: true, error: false });

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = () => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order`,
      headers: {
        Authorization: Auth(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        setAllOrder(response.data);
        setIsLoading({ loading: false, error: false });
      })
      .catch((error) => {
        console.log(error);
        setIsLoading({ loading: false, error: true });
      });
  };

  const refreshOrders = (data) => {
    if (data) {
      setAllOrder(data)
    } else {
      fetchOrders()
    }
  };

  return (
    <Fragment>
      <Box p={5} flex="1" w={"100%"}>
        <AllOrder
          title={"All Orders"}
          head={[
            "Order",
            "Date",
            "Customer Name",
            "Total",
            "Items",
            "Order Status",
            "Action",
            "",
          ]}
          data={allOrder}
          isLoading={isLoading}
          refreshOrders={refreshOrders}
        />
      </Box>
    </Fragment>
  );
};
export default OrdersAll;
